import { windowSizeCategories } from "../_const/windowSize.const";

export function getSizeCategory(width: number, height: number) {
    for (let category of windowSizeCategories) {
        if (width <= category.maxWidth && height <= category.maxHeight) {
            return category.name;
        }
    }
    return 'unknown';
}

export function getWindowSizeCategory() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    return getSizeCategory(width, height);
}
